import { useState, useMemo, useCallback } from 'react'

const useTableSort = (rows, getSortValue) => {
  const [sortColumn, setSortColumn] = useState(null)
  const [sortDirection, setSortDirection] = useState(null)

  const handleSort = useCallback(column => {
    if (sortColumn !== column) {
      setSortColumn(column)
      setSortDirection('asc')
    } else if (sortDirection === 'asc')
      setSortDirection('desc')
    else {
      setSortColumn(null)
      setSortDirection(null)
    }
  }, [sortColumn, sortDirection])

  const sortedRows = useMemo(() => {
    if (!rows?.length || !sortColumn)
      return rows || []

    return [...rows].sort((rowA, rowB) => {
      const valueA = getSortValue(rowA, sortColumn)
      const valueB = getSortValue(rowB, sortColumn)

      if (typeof valueA === 'string')
        return sortDirection === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA)

      return sortDirection === 'asc' ? valueA - valueB : valueB - valueA
    })
  }, [rows, sortColumn, sortDirection, getSortValue])

  const sortProps = useCallback(key => ({
    currentSort: sortColumn,
    sortDirection,
    sortKey: key,
    onSort: handleSort
  }), [sortColumn, sortDirection, handleSort])

  return { sortedRows, sortProps }
}

export default useTableSort
